import React from 'react';
import Done from '@mui/icons-material/Done';
import Remove from '@mui/icons-material/Remove';

const emptyCellFiller = field => field ? field : '-';

export default user => {
  const columns = [
    {
      title: 'Produto Final',
      field: 'excluded_from_final_product',
      sorting: false,
      minWidth: 50,
      headerStyle: {
        textAlign: 'center',
      },
      cellStyle: {
        textAlign: 'center',
      },
      type: 'boolean',
      initialEditValue: 'false',
      lookup: {
        true: <Remove style={{ height: 16, width: 16 }}/>,
        false: <Done style={{ height: 16, width: 16 }}/>
      },
      render: rowData => {
        if (rowData.excluded_from_final_product === 'true' || rowData.excluded_from_final_product === true) {
          return <Remove style={{ height: 16, width: 16 }}/>;
        } else if (rowData.excluded_from_final_product === 'false' || rowData.excluded_from_final_product === false) {
          return <Done style={{ height: 16, width: 16 }}/>;
        }
      },
    },
    {
      title: 'Campo 3 FDS',
      field: 'contributes_to_hazard',
      sorting: false,
      minWidth: 50,
      headerStyle: {
        textAlign: 'center',
      },
      cellStyle: {
        textAlign: 'center',
      },
      type: 'boolean',
      initialEditValue: 'false',
      lookup: {
        true: <Done style={{ height: 16, width: 16 }}/>,
        false: <Remove style={{ height: 16, width: 16 }}/>
      },
      render: rowData => {
        if (rowData.contributes_to_hazard === 'true' || rowData.contributes_to_hazard === true) {
          return <Done style={{ height: 16, width: 16 }}/>;
        } else if (rowData.contributes_to_hazard === 'false' || rowData.contributes_to_hazard === false) {
          return <Remove style={{ height: 16, width: 16 }}/>;
        }
      },
    },
    {
      title: 'Nome Substância',
      field: 'name',
      editable: 'never',
      minWidth: 200,
      headerStyle: {
        textAlign: 'center',
      },
      cellStyle: {
        textAlign: 'left',
      },
      render: ({ name }) => emptyCellFiller(name),
    },
    {
      title: 'CAS',
      field: 'cas',
      editable: 'never',
      minWidth: 100,
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
      render: rowData => rowData.cas && rowData.cas.length !== 0 ? rowData.cas.join(', ') : '-',
    },
    {
      title: 'EC',
      field: 'ec',
      editable: 'never',
      minWidth: 100,
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
      render: rowData => rowData.ec && rowData.ec.length !== 0 ? rowData.ec.join(', ') : '-',
    },
  ];

  const columnsAdmin = [
    {
      title: 'ID',
      field: 'id',
      editable: 'never',
      width: 100,
    },
    ...columns
  ];

  return user.superuser ? columnsAdmin : columns;
};
